<template>
  <div v-cloak class="row justify-content-center">
    <div class="col col-sm-8 align-self-center">
      <div class="card">
        <div class="card-body">
          <div v-if="hours < 48 && initial_quote.order_status_id == quote_status">
            <div class="row my-3">
              <div class="col d-flex justify-content-center align-items-center">
                <h1 class="mb-0">Plase select a new delivery date</h1>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col d-flex justify-content-center align-items-center">
                <div class="form-group col-md-4">
                  <label for="delivery_date">Delivery Date</label>
                  <div class="input-group">
                    <el-date-picker
                      v-model="initial_quote.delivery_date"
                      id="delivery_date"
                      type="date"
                      placeholder="Pick a date"
                      value-format="yyyy-MM-dd HH:mm:00"
                      format="dd/MM/yyyy"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="form-group col-md-2 pt-4">
                  <button
                    class="btn btn-sm btn-primary mr-4"
                    @click="handleUpdateQuote"
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row my-3">
              <div class="col d-flex justify-content-center align-items-center">
                <h1 class="mb-0">Quote has been Confirmed</h1>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col d-flex justify-content-center align-items-center">
                <p>Thank you. You may close this page now.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Form from "form-backend-validation";
import Quote from "../models/Quote";
export default {
  props: {
    hours: {
      type: Number
    },
    quote: {
      type: Object
    },
    quote_status: {
      type: Number
    },
  },
  data() {
    return {
      delivery_date: null,
      initial_quote: new Quote({
        order_status_id: this.quote.order_status_id,
        delivery_date: null,
        id: this.quote.id
      }),
      form: new Form(),
      pickerOptions: {
        disabledDate(time) {
          return (
            new Date(time).getDay() === 1 ||
            new Date(time).getDay() === 0 ||
            time < new Date(new Date().getTime() + 60 * 60 * 48 * 1000)
          );
        }
      }
    };
  },
  methods: {
    handleUpdateQuote() {
      let self= this;

      this.initial_quote
        .save()
        .then(res => {
          this.$message({
            type: "success",
            message: "Saved"
          });
          self.initial_quote = res;
        })
        .catch(errors => {
          this.form.errors.record(errors.response.data.errors);
          var errorText = "";
          _.forEach(errors.response.data.errors, function(value) {
            errorText += "" + value + " ";
          });
          this.$message({
            type: "error",
            message: errorText
          });
        });
    }
  }
};
</script>
